import { Song } from "@/javascript/library-objects";
import { Box, Group, Skeleton } from '@mantine/core';
import React from "react";
import SongBlock from "./SongBlock";

interface SongGridProps {
	songs: Song[] | null | undefined;
	type: "marketplace" | "library";
	skeletonSize: number
}

const SongGrid: React.FC<SongGridProps> = ({ songs, type, skeletonSize }) => {
	const isLoading = !songs

	return (
		<Group
			w="100%"
			justify="center"
			style={{ margin: 0 }}
		>
			<Box
				w="100%"
				style={{
					display: "grid",
					gridTemplateColumns: "repeat(auto-fit, minmax(300px, max-content))",
					gap: "2rem",
					justifyContent: "center",
				}}
			>
				{isLoading
					? Array.from({ length: skeletonSize }).map((_, i) => (
						<Skeleton key={i} h={type === "marketplace" ? 480 : 400} w={300} radius="md" />
					))
					: songs.map((song) => (
						<SongBlock
							key={song.songId}
							song={song}
							type={type}
						/>
					))}
			</Box>
		</Group>
	);
};

export default SongGrid;